module.exports = __webpack_public_path__ + "img/underline-secondary.3e3a4d6.svg";